// 本地环境配置
module.exports = {
  title: '',
  baseUrl: 'http://localhost:9018',
  // 项目地址
  baseApi: 'https://developer.m2.xingshentech.com',
  // 本地api请求地址,注意：如果你使用了代理，请设置成'/'
  APPID: 'xxx',
  APPSECRET: 'xxx'
  // $cdn: 'https://www.sunniejs.cn/static'
};